<template>
    <v-form ref="form" v-if="entry">
        <v-card flat>
            <div class="v-flex" v-if="isReminder">
                <f-date-picker
                    v-model = "time"
                    label   = "Zeit"
                    :time   = "true"
                    class   = "mr-2"
                    :rules  = "[rules.required]"
                />
                <v-select
                    v-model    = "entry.frequency"
                    class      = "crm-reminder-frequency ml-2"
                    item-value = "id"
                    item-text  = "name"
                    :items     = "frequency"
                    label      = "Frequenz"
                />
            </div>

            <v-text-field
                v-if    = "!isPostponement && !isClipboard && !isDocument"
                v-model = "entry.subject"
                label   = "Thema"
                :rules  = "[rules.required]"
            />

            <f-read-only-field
                label  ="Thema"
                :value = "$t(entry.subject)"
                filled
            />

            <v-row class="no-frame mt-2" v-if="isPostponement">
                <v-col class="no-frame pr-2">
                    <f-read-only-field
                        :label = "$t('inc.assessment.postponment.currentDate')"
                        :value ="dateScheduled"
                        color  = "primary white--text space pl-1"
                        dense
                    />
                </v-col>
                <v-col class="no-frame pl-2">
                    <f-read-only-field
                        :label = "$t('inc.assessment.postponment.newDate')"
                        :value ="dateScheduledNew"
                        color = "primary white--text space pl-1"
                        dense
                    />
                </v-col>
            </v-row>
            <v-row class="no-frame mt-5" v-if="isPostponement">
                <v-col class="no-frame pr-2">
                    <f-enum-select
                        v-model   = "entry.postponement"
                        :label    = "$t('inc.assessment.postponment.reason')"
                        module    = "inc"
                        type      = "postponmentType"
                        :rules  = "[rules.required]"
                    />
                </v-col>
                <v-col class="no-frame pr-2">
                    <f-date-picker
                        label   = "inc.assessment.postponment.received"
                        v-model = "entry.time"
                        :time   = "true"
                        :rules  = "[rules.required]"
                    />
                </v-col>
            </v-row>

            <v-textarea
                v-model        = "entry.description"
                rows           = "5"
                class          ="crm-textarea mt-3"
                label          = "Notiz"
                autocomplete   = "off"
                autocorrect    = "off"
                autocapitalize = "off"
                spellcheck     = "false"
                hide-details   = "true"
                flat
                no-resize
            />

            <crm-edit-partner
                v-if    = "showPartner"
                v-model = "entry.partner"
                class   =  "mt-4"
                :label  = "isPostponement ? 'Gemeldet von' : 'Gesprächspartner'"
            />
        </v-card>
    </v-form>
</template>

<script>

import Core           from "@/modules/core/service/Core";
import FDatePicker    from "@/modules/core/components/utils/FDatePicker";
import CrmEditPartner from "@/modules/crm/components/main/CrmEditPartner";
import Crm            from "@/modules/crm/service/Crm.ts";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField";
import FEnumSelect    from "@/modules/core/components/utils/FEnumSelect";

export default {
    name: "CrmEntryEdit",
    components: {
        FEnumSelect,
        FReadOnlyField,
        CrmEditPartner,
        FDatePicker
    },

    props: {
        incident: {
            required: true,
            type: Object,
        },

        entry: {
            required: true,
            type    : Object,
        }
    },

    data() {
        return {
            time: null,
            format: "dd.MM.yyyy",
            frequency: [
                { id: 1, name: 'einmalig' },
                { id: 2, name: 'wöchentlich' },
                { id: 3, name: 'monatlich' },
                { id: 4, name: 'quartalsweise' },
                { id: 5, name: 'halbjährlich' },
                { id: 6, name: 'jährlich' }
            ]
        }
    },

    computed: {
        rules () {
            return Core.rule;
        },

        create () {
            return this.entry.id === null;
        },

        showPartner () {
            return this.isReminder || this.isPhone || this.isPostponement
        },

        isPhone () {
            return this.entry.type.id === Crm.journal.type.phone;
        },

        isDocument () {
            return this.entry.type.id === Crm.journal.type.document;
        },

        isClipboard () {
            return this.entry.type.id === Crm.journal.type.clipboard;
        },

        isReminder () {
            return this.entry.type.id === Crm.journal.type.reminder;
        },

        isPostponement () {
            return this.entry.type.id === Crm.journal.type.postponement;
        },

        dateScheduled () {
            return Core.format.date.display(this.entry.dateScheduled);
        },

        dateScheduledNew () {
            return Core.format.date.display(this.entry.dateScheduledNew);
        }
    },

    created: function () {
        this.$bus.$on(this.$incident.events.save, this.onSave)
    },

    beforeDestroy() {
        this.$bus.$off(this.$incident.events.save, this.onSave)
    },

    mounted() {
        this.freeze = JSON.stringify(this.entry);
        this.time = this.entry.time;
    },

    methods: {
        save () {
            this.entry.incident.id = this.incident.id;
            this.entry.incident.sites = this.incident.sites;
            this.entry.time = this.time;

            if (this.isPostponement) {
                this.entry.subject = "Terminverschiebung zum " + this.dateScheduledNew;
            }

            this.entry.unitId = this.$store.getters.site.id;
            Crm.save(this.entry.type.id, this.entry, () => {
                this.$emit(Crm.events.saved, true);
                this.freeze = JSON.stringify(this.entry);
            })
        },

        onSave () {
            const form = this.$refs.form;
            if (!form.validate ()) {
                return;
            }

            const json = JSON.stringify(this.entry);
            if (this.freeze === json) {
                this.$emit(Crm.events.saved, false);
                return;
            }

            this.save();
        },

        onDelete (value) {
            if (!value) return;
            const self = this;
            Crm.delete(this.entry.id, () => {
                self.$emit(Crm.events.deleted);
            })
        },

        onUnDelete (value) {
            if (!value) return;
            this.entry.incident.id = this.incident.id;
            this.entry.incident.sites = this.incident.sites;
            Crm.save( this.entry.type.id, this.entry, () => {
                this.freeze = JSON.stringify(self.this);
                this.$emit(Crm.events.undeleted);
            })
        },

        onCancel () {
            this.$emit(Crm.events.cancel);
        }
    }
}
</script>

<style scoped>

.crm-reminder-frequency {
    width: 200px;
}

::v-deep .space {
    padding-top: 3px;
}

</style>